import { StandardBagAncillarySsrs, StandardBagSsrs } from './bags.constants';

export const DEFAULT_SCROLL_DURATION = 300;
export const HEADER_HEIGHT = 64;
export const INPUT_HEIGHT = 58;
export const TOP_OFFSET = 10;
export const MINOR_AGE_UPPER_CUTOFF = 18;
export const SENIOR_AGE_LOWER_CUTOFF = 64;
export const DEFAULT_ASSUMED_AGE = 35;
export const PAYMENT_METHOD_MAX_LENGTH_DEFAULT = 19;
export const PAYMENT_METHOD_CVV_MAX_LENGTH_DEFAULT = 4;
export const PAYMENT_METHOD_CVV_MIN_LENGTH_DEFAULT = 3;
export const PAYMENT_CARD_YEARS_LIMIT_DEFAULT = 10;
export const DEFAULT_CREDIT_CARD_MASK = '0000 0000 0000 0000';
export const MIN_INFANT_AGE_DAYS = 7;
export const MAX_INFANT_AGE_YEARS = 2;
export const MIN_CHILD_AGE_YEARS = 2;
export const MAX_CHILD_AGE_YEARS = 18;
export const MAX_CHD_AGE_YEARS = 12;
export const MIN_CHD_AGE_YEARS = 2;
export const MAX_OTN_AGE_YEARS = 18;
export const MIN_OTN_AGE_YEARS = 16;
export const MAX_TEN_AGE_YEARS = 16;
export const MIN_TEN_AGE_YEARS = 13;
export const MAX_YTN_AGE_YEARS = 13;
export const MIN_YTN_AGE_YEARS = 12;
export const MAX_INF_AGE_YEARS = 2;
export const MIN_INF_AGE_YEARS = 0;
export const MAX_INS_AGE_YEARS = 2;
export const MIN_INS_AGE_YEARS = 0;
export const MIN_SEATS_LEFT = 0;
export const DEFAULT_LOADER_TIMEOUT = 8000;
export const DEFAULT_COOKIE_MODAL_TIMEOUT_MILLIS = 1000;
export const SECONDS_PER_MINUTE = 60;
export const MINUTES_PER_HOUR = 60;
export const HOURS_PER_DAY = 24;
export const DAYS_PER_STANDARD_YEAR = 365;
export const SECONDS_PER_DAY =
  SECONDS_PER_MINUTE * MINUTES_PER_HOUR * HOURS_PER_DAY;
export const SECONDS_PER_YEAR = SECONDS_PER_DAY * DAYS_PER_STANDARD_YEAR;
export const MILLISECONDS_PER_SECOND = 1000;
export const MILLISECONDS_PER_MINUTE =
  SECONDS_PER_MINUTE * MILLISECONDS_PER_SECOND;
export const MILLISECONDS_PER_HOUR = MILLISECONDS_PER_MINUTE * MINUTES_PER_HOUR;
export const MILLISECONDS_PER_DAY = MILLISECONDS_PER_HOUR * HOURS_PER_DAY;
export const HOME_PAGE = 'home';
export const NOT_FOUND_PAGE = 'not-found';
export const PRIMARY_CONTACT_TYPE_CODE = 'P';
export const WARN_USER_TOKEN_TIMEOUT_MINUTES = 5;
export const DEFAULT_TOKEN_TIMEOUT_MINUTES = 15;
export const MONEY_BACK_GUARANTEE_HOUR_LIMIT = 24;
export const MONEY_BACK_GUARANTEE_FLIGHT_DAY_LIMIT = 8;
export const GEOLOCATION_PERMISSION_PROMPT_TIMEOUT = 30000;
export const GEOLOCATION_PERMISSION_QUERY_TIMEOUT = 5000;
export const GEOLOCATION_PERMISSION_FETCH_TIMEOUT = 10000;
export const XHR_TIMEOUT = 5000;

export const COUNTRY_CODE_US = 'US';
export const COUNTRY_CODE_CA = 'CA';
export const COUNTRY_CODE_FR = 'FR';
export const COUNTRY_CODE_GB = 'GB';
export const COUNTRY_CODE_UK = 'UK';
export const COUNTRY_CODE_NO = 'NO';
export const COUNTRY_CODE_DE = 'DE';
export const COUNTRY_CODE_IT = 'IT';
export const COUNTRY_CODE_TH = 'TH';
export const COUNTRY_CODE_JM = 'JM';
export const COUNTRY_CODE_BB = 'BB';
export const COUNTRY_CODE_ZA = 'ZA';
export const COUNTRY_CODE_SE = 'SE';

export const CURRENCY_USD = 'USD';
export const CURRENCY_GBP = 'GBP';
export const CURRENCY_NOK = 'NOK';
export const CURRENCY_EUR = 'EUR';
export const CURRENCY_ZAR = 'ZAR';
export const CURRENCY_SEK = 'SEK';
export const FALLBACK_CURRENCY = CURRENCY_USD;
export const GEOLOCATION_FALLBACK_CURRENCY = CURRENCY_USD;

export const PREMIUM_CABIN_DESIGNATOR = 'W';
export const ECONOMY_CABIN_DESIGNATOR = 'Y';
export const PREMIUM_CABIN = 'Premium';
export const ECONOMY_CABIN = 'Economy';
export const REGULAR_SEAT_SIZE = 2;
export const AISLE_SIZE = 0.75;
export const PREFERRED_SEAT_GROUP = 12;
export const EXIT_ROW_SEAT_GROUP = 10;
export const SEAT_CODE_LEGROOM = 'LEGROOM';
export const SEAT_CODE_WINDOW = 'WINDOW';
export const SEAT_CODE_AISLE = 'AISLE';
export const SEAT_CODE_BASSINET = 'BASSINET';
export const SEAT_CODE_BOARDING_ZONE = 'BRDZONE';
export const SEAT_CODE_WINDOW_NO_WINDOW = 'NWINDOW';
export const SEAT_CODE_EXIT_ROW = 'EXITROW';
export const SEAT_CODE_RESTRICTED_RECLINE = 'RECLINE';
export const SEAT_CODE_STANDARD_LEG_ROOM = 'STDLEG';
export const SEAT_CODE_MORE_LEG_ROOM = 'MORELEG';
export const SEAT_CODE_BETTER_LEG_ROOM = 'BETLEG';
export const RECOMMENDED_BUNDLE = 'EC';
export const RECOMMENDED_BAG = StandardBagSsrs.CLASSIC_CHECKED_BAG;
export const RECOMMENDED_ANCILLARY_BAG = StandardBagAncillarySsrs.CLASSIC_CHECKED_BAG;
export const NAME_CHANGE_SSR_1 = 'NMCO';
export const NAME_CHANGE_SSR_2 = 'NAME';
export const BREAKPOINT_MOBILE = 768;
export const BREAKPOINT_MOBILE_SMALL = 540;
export const BREAKPOINT_TABLET = 992;
export const BREAKPOINT_MEDIUM_DESKTOP = 1200;
export const BREAKPOINT_LARGE_DESKTOP = 1400;
export const DEVICE_HEIGHT_SMALL = 843;
export const REGEX_PASSWORD =
  /(?=^\S{8,16}$)(?=.*?\d)(?=.*?[A-Z])(?=.*?[a-z])(?=.*?\W)(?!.*?[.,~])/;
export const REGEX_IOS_VERSION =
  /(iPad|iPhone|iphone|iPod).*?(OS |os |OS_)(\d+((_|\.)\d)?((_|\.)\d)?)/;
export const FARE_CLASS_NOT_AVAILABLE_ERROR_CODE =
  'nsk-server:ClassNotAvailable';
export const TOKEN_TIMEOUT_ERROR_CODE = 'core:Token:Timeout';
export const TOKEN_UNAUTHORIZED_ERROR_CODE = 'n0:Token:Unauthorized';
export const AGENT_AUTHENTICATION_ERROR_CODE = 'nsk-server:AgentAuthentication';
export const PAYMENT_GREATER_THAN_DUE_ERROR_CODE =
  'n0:Payment:PaymentAmountGreaterThanDue';
export const BOOKING_NOT_FOUND_ERROR_CODE = 'n0:Trip:CodeNameMismatch';
export const MAX_CONSECUTIVE_DECLINED_PAYMENTS = 5;
export const PROMO_CODE_INVALID = 'nsk-server:PromotionNotFound';
export const BASE_64_IMAGE_PREFIX = 'data:image/jpg;base64,';
export const VIEW_BOARDING_PASS_QUERY_PARAM = 'viewBoardingPass';
export const MODAL_DIALOG_STANDARD_WIDTH = 'standard-modal-width';
export const MODAL_DIALOG_FULL_SCREEN = 'modal-dialog-fullscreen';
export const MODAL_DIALOG_CENTER = 'modal-dialog-float';
export const MODAL_DIALOG_CENTER_LG = 'modal-dialog-float';
export const MODAL_DIALOG_LIMITED_WIDTH = 'modal-dialog-limited-width';
export const MODAL_DIALOG_LIMITED_WIDTH_600 = 'modal-dialog-limited-width-600';
export const MODAL_DIALOG_LIMITED_WIDTH_600_WITH_ODIN = 'modal-dialog-limited-width-600-with-odin';
export const MODAL_THREE_TAILS_IMG =
  'https://assets.flynorse.com/static/site/modals/three-tails.jpg';

export const CULTURE_US = 'en-US';
export const CULTURE_US_LOWER = 'en-us';
export const FALLBACK_CULTURE = CULTURE_US;
export const CULTURE_FRENCH = 'fr-FR';
export const CULTURE_FRENCH_LOWER = 'fr-fr';
export const CULTURE_GREAT_BRITAIN = 'en-GB';
export const CULTURE_GREAT_BRITAIN_LOWER = 'en-gb';
export const GEOLOCATION_FALLBACK_CULTURE = CULTURE_US;
export const CULTURE_NORWAY = 'nb-NO';
export const CULTURE_NORWAY_LOWER = 'nb-no';
export const CULTURE_SPAIN = 'es-ES';
export const CULTURE_SPAIN_LOWER = 'es-es';
export const CULTURE_GERMANY = 'de-DE';
export const CULTURE_GERMANY_LOWER = 'de-de';
export const CULTURE_ITALY = 'it-IT';
export const CULTURE_ITALY_LOWER = 'it-it';
export const CULTURE_US_SPANISH = 'es-US';
export const CULTURE_US_SPANISH_LOWER = 'es-us';

export const LOCALE_KEY_FR_FR = 'fr';
export const LOCALE_KEY_DE_DE = 'de';
export const LOCALE_KEY_NB_NO = 'nb';
export const LOCALE_KEY_ES_ES = 'es';
export const LOCALE_KEY_EN_GB = 'engb';
export const LOCALE_KEY_IT_IT = 'it';
export const LOCALE_KEY_ES_US = 'esus';

export const PARAM_REDIRECTID_KEY = 'redirectid';

export enum QuasiContinent {
  America = 'US',
  NotAmerica = 'Europe',
}

export const CULTURE_CODE_REGEX = /^[a-z]{2}-[a-z]{2}$/i;

export const CULTURES = [
  CULTURE_US_LOWER,
  CULTURE_US,
  CULTURE_GREAT_BRITAIN_LOWER,
  CULTURE_GREAT_BRITAIN,
  CULTURE_FRENCH_LOWER,
  CULTURE_FRENCH,
  CULTURE_NORWAY_LOWER,
  CULTURE_NORWAY,
  CULTURE_GERMANY_LOWER,
  CULTURE_GERMANY,
  CULTURE_ITALY_LOWER,
  CULTURE_ITALY,
  CULTURE_US_SPANISH,
  CULTURE_US_SPANISH_LOWER,
] as const;

export type CultureKeyType = (typeof CULTURES)[number];

export const HEADER_ORDERED_CULTURES = [
  CULTURE_US_LOWER,
  CULTURE_US,
  CULTURE_US_SPANISH,
  CULTURE_US_SPANISH_LOWER,
  CULTURE_GREAT_BRITAIN_LOWER,
  CULTURE_GREAT_BRITAIN,
  CULTURE_FRENCH_LOWER,
  CULTURE_FRENCH,
  CULTURE_ITALY_LOWER,
  CULTURE_ITALY,
  CULTURE_NORWAY_LOWER,
  CULTURE_NORWAY,
  CULTURE_GERMANY_LOWER,
  CULTURE_GERMANY,
]

export const CURRENCIES = [
  CURRENCY_USD,
  CURRENCY_GBP,
  CURRENCY_NOK,
  CURRENCY_EUR,
  CURRENCY_ZAR,
  CURRENCY_SEK
] as const;

export type CurrencyKeyType = (typeof CURRENCIES)[number];

export const DURATION_FORMAT_BY_CULTURE: {
  [key in CultureKeyType]: string;
} = {
  [CULTURE_FRENCH]: "h'h' mm'm'",
  [CULTURE_FRENCH_LOWER]: "h'h' mm'm'",
  [CULTURE_US]: "h'hr' mm'min'",
  [CULTURE_US_LOWER]: "h'hr' mm'min'",
  [CULTURE_NORWAY_LOWER]: "h't' mm'min'",
  [CULTURE_NORWAY]: "h't' mm'min'",
  [CULTURE_GREAT_BRITAIN_LOWER]: "h'hr' mm'min'",
  [CULTURE_GREAT_BRITAIN]: "h'hr' mm'min'",
  [CULTURE_GERMANY_LOWER]: "h'std' mm'min'",
  [CULTURE_GERMANY]: "h'std' mm'min'",
  [CULTURE_ITALY_LOWER]: "h'hr' mm'min'",
  [CULTURE_ITALY]: "h'hr' mm'min'",
  [CULTURE_US_SPANISH]: "h'hr' mm'min'",
  [CULTURE_US_SPANISH_LOWER]: "h'hr' mm'min'",
};

export const DEFAULT_COUNTRY_CODE_BY_CULTURE: {
  [key in CultureKeyType]: string;
} = {
  [CULTURE_FRENCH]: COUNTRY_CODE_FR,
  [CULTURE_FRENCH_LOWER]: COUNTRY_CODE_FR,
  [CULTURE_US]: COUNTRY_CODE_US,
  [CULTURE_US_LOWER]: COUNTRY_CODE_US,
  [CULTURE_NORWAY_LOWER]: COUNTRY_CODE_NO,
  [CULTURE_NORWAY]: COUNTRY_CODE_NO,
  [CULTURE_GREAT_BRITAIN_LOWER]: COUNTRY_CODE_GB,
  [CULTURE_GREAT_BRITAIN]: COUNTRY_CODE_GB,
  [CULTURE_GERMANY_LOWER]: COUNTRY_CODE_DE,
  [CULTURE_GERMANY]: COUNTRY_CODE_DE,
  [CULTURE_ITALY_LOWER]: COUNTRY_CODE_IT,
  [CULTURE_ITALY]: COUNTRY_CODE_IT,
  [CULTURE_US_SPANISH]: COUNTRY_CODE_US,
  [CULTURE_US_SPANISH_LOWER]: COUNTRY_CODE_US,
};

export const DEFAULT_COORDS_BY_CULTURE: {
  [key in CultureKeyType]: { lat: number; lon: number };
} = {
  [CULTURE_FRENCH]: { lat: 48.8566, lon: 2.3522 }, // Paris, France
  [CULTURE_FRENCH_LOWER]: { lat: 48.8566, lon: 2.3522 },
  [CULTURE_US]: { lat: 40.7128, lon: -74.0060 }, // New York, USA
  [CULTURE_US_LOWER]: { lat: 40.7128, lon: -74.0060 },
  [CULTURE_NORWAY_LOWER]: { lat: 59.9139, lon: 10.7522 }, // Oslo, Norway
  [CULTURE_NORWAY]: { lat: 59.9139, lon: 10.7522 },
  [CULTURE_GREAT_BRITAIN_LOWER]: { lat: 51.5074, lon: -0.1278 }, // London, UK
  [CULTURE_GREAT_BRITAIN]: { lat: 51.5074, lon: -0.1278 },
  [CULTURE_GERMANY_LOWER]: { lat: 52.5200, lon: 13.4050 }, // Berlin, Germany
  [CULTURE_GERMANY]: { lat: 52.5200, lon: 13.4050 },
  [CULTURE_ITALY_LOWER]: { lat: 41.9028, lon: 12.4964 }, // Rome, Italy
  [CULTURE_ITALY]: { lat: 41.9028, lon: 12.4964 },
  [CULTURE_US_SPANISH]: { lat: 25.7617, lon: -80.1918 }, // Miami, Florida
  [CULTURE_US_SPANISH_LOWER]: { lat: 25.7617, lon: -80.1918 },
};

export const DO_HOP_FEATURED_STATIONS = ['AMS', 'MAD', 'BCN', 'CPH', 'WAW'];

export const LOUNGE_SSRS = ['LBKK', 'LCDG', 'LFCO', 'LJFK', 'LMCO', 'LNGE', 'LOSL', 'LARN'];

export const QUASI_CONTINENT_US_COUNTRIES = [
  COUNTRY_CODE_US,
  COUNTRY_CODE_CA,
  COUNTRY_CODE_JM,
  COUNTRY_CODE_BB,
  COUNTRY_CODE_TH,
];

export const COUNTRY_CODE_TO_CURRENCY: {
  [countryCode: string]: string | undefined;
} = {
  [COUNTRY_CODE_NO]: CURRENCY_NOK,
  [COUNTRY_CODE_DE]: CURRENCY_EUR,
  [COUNTRY_CODE_FR]: CURRENCY_EUR,
  [COUNTRY_CODE_IT]: CURRENCY_EUR,
  [COUNTRY_CODE_GB]: CURRENCY_GBP,
  [COUNTRY_CODE_UK]: CURRENCY_GBP,
  [COUNTRY_CODE_US]: CURRENCY_USD,
  [COUNTRY_CODE_CA]: CURRENCY_USD,
  [COUNTRY_CODE_TH]: CURRENCY_NOK,
  [COUNTRY_CODE_JM]: CURRENCY_USD,
  [COUNTRY_CODE_BB]: CURRENCY_USD,
  [COUNTRY_CODE_ZA]: CURRENCY_ZAR,
  [COUNTRY_CODE_SE]: CURRENCY_SEK
};

export const COUNTRY_CODE_TO_CULTURE: {
  [countryCode: string]: CultureKeyType | undefined;
} = {
  [COUNTRY_CODE_NO]: CULTURE_NORWAY,
  [COUNTRY_CODE_DE]: CULTURE_GERMANY,
  [COUNTRY_CODE_FR]: CULTURE_FRENCH,
  [COUNTRY_CODE_GB]: CULTURE_GREAT_BRITAIN,
  [COUNTRY_CODE_UK]: CULTURE_GREAT_BRITAIN,
  [COUNTRY_CODE_US]: CULTURE_US,
  [COUNTRY_CODE_CA]: CULTURE_US,
  [COUNTRY_CODE_IT]: CULTURE_ITALY,
  [COUNTRY_CODE_TH]: CULTURE_GREAT_BRITAIN,
  [COUNTRY_CODE_JM]: CULTURE_US,
  [COUNTRY_CODE_BB]: CULTURE_US,
  [COUNTRY_CODE_ZA]: CULTURE_US,
  [COUNTRY_CODE_SE]: CULTURE_GREAT_BRITAIN
};

export const CURRENCY_CODE_TO_CULTURE: {
  [currenyCode: string]: CultureKeyType | undefined;
} = {
  [CURRENCY_NOK]: CULTURE_NORWAY,
  [CURRENCY_EUR]: CULTURE_FRENCH,
  [CURRENCY_GBP]: CULTURE_GREAT_BRITAIN,
  [CURRENCY_ZAR]: FALLBACK_CULTURE,
  [CURRENCY_USD]: CULTURE_US,
  [CURRENCY_SEK]: CULTURE_GREAT_BRITAIN
};

export const DISPLAY_EXCLUDED_CURRENCY_SYMBOLS = [
  CURRENCY_NOK,
  CURRENCY_ZAR,
  CURRENCY_SEK
]

export const COUNTRY_CODE_TO_AIRPORT_CODE: {
  [countryCode: string]: string | undefined;
} = {
  [COUNTRY_CODE_NO]: 'OSL',
  [COUNTRY_CODE_DE]: 'BER',
  [COUNTRY_CODE_FR]: 'CDG',
  [COUNTRY_CODE_GB]: 'LGW',
  [COUNTRY_CODE_UK]: 'LGW',
  [COUNTRY_CODE_IT]: 'FCO',
  [COUNTRY_CODE_ZA]: 'CPT',
  [COUNTRY_CODE_SE]: 'ARN'
};

export enum FlowBaseUrlEnum {
  BOOK = 'book',
  MODIFY = 'modify',
  TRIPS = 'trips',
  CAR_RENTAL = 'car-rental',
  CANCEL = 'cancel',
  CHECK_IN = 'check-in',
  PAY = 'pay',
  UPGRADE = 'upgrade',
  ACCOUNT = 'account',
  UPLIFT = 'uplift',
  FLEXPAY = 'flexpay',
  MULTICITY = 'multicity',
  THEME = 'theme',
}

export enum DynamicFlowBaseUrlEnum {
  EXPERIENCE = 'experience',
  SUPPORT = 'support',
  CORPORATE = 'corporate',
}

export enum CookieConsentOptions {
  ALL = 'all',
  ESSENTIAL = 'essential',
  MARKETING = 'marketing',
}

export enum MobileBreadcrumbCollapseEnum {
  BREADCRUMB = 'BREADCRUMB',
  SUMMARY = 'SUMMARY',
  NONE = 'NONE',
}

export enum ApiResponseErrorBypassCodes {
  CREDENTIALS_FAILED = 'nsk-server:Credentials:Failed',
  VERIFICATION_FAILED = 'n0:Login:VerificationFailed',
}

export enum PaymentCodes {
  CreditShell = 'CS',
  Other = 'OT',
  Voucher = 'VO',
  CreditFile = 'CF',
  Agency = 'AG',
  Cash = 'CA',
  VoucherAdjustment = 'VA',
  AmericanExpress = 'AX',
  MasterCard = 'MC',
  Visa = 'VI',
  BidForUpgrade = 'PG',
  CustomerCare = 'CC',
  DutyTravel = 'DT',
}

export enum WindowSizeClassification {
  Desktop,
  Mobile,
  MediumDesktop,
  SmallMobile,
  LargeDesktop,
  Tablet,
}

export enum DeviceHeightClassification {
  Small,
  Other,
}

export const CULTURE_ROUTE_PARAM = 'culture';

// HTTP Headers constants
export const HEADERS_GEO_CLIENT_COUNTRY = 'Geoclientcountry';
export const HEADERS_GEO_CLIENT_IP = 'Geoclientip';


// List of hidden promo codes to not display in system
export const HIDDEN_PROMO_CODES_LIST = [
  'RTD',
  'RTD5',
  'RTD10',
  'RTD20',
]

export const SCROLL_CONTAINER_ID = 'scroll-container';
export const RUDDERSTACK_USER_ID_QUERY_PARAM_NAME = 'n0aid';
export const GROWTHBOOK_OPTION_KEY = 'n0gb';

export const MOBILE_APP_SCHEME = 'norse';
export const MOBILE_APP_REFERRAL = 'n0app-referral';
export const MOBILE_APP_CALLBACK_URL = 'n0app-callback-url';

export const routeDiscountMap = {
  'JFK-ATH': 0.20,
  'BER-JFK': 0.15,
  'JFK-BER': 0.10,
  'CDG-JFK': 0.20,
  'JFK-CDG': 0.10,
  'CDG-LAX': 0.20,
  'LAX-CDG': 0.15,
  'LGW-CPT': 0.20,
  'FCO-JFK': 0.10,
  'JFK-FCO': 0.20,
  'LGW-JFK': 0.20,
  'JFK-LGW': 0.10,
  'LGW-LAS': 0.10,
  'LGW-LAX': 0.20,
  'LGW-MCO': 0.20,
  'MCO-LGW': 0.15,
  'LGW-MIA': 0.20,
  'MIA-LGW': 0.20
};
